import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconTrophy({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<path
					id="a"
					d="M10.619 12.075c.568-.16 1.16-.322 1.686-.727.525-.405.944-.84 1.167-1.544q.473-.96.333-8.87V0H5.876v.933q-.14 7.911.334 8.871c.222.705.582 1.14 1.167 1.544.584.405 1.118.567 1.686.727s.988.16 1.556 0"
				/>
			</defs>
			<g fill="none" fillRule="evenodd" transform="translate(2 2)">
				<path
					fill="#CD0400"
					fillRule="nonzero"
					d="M15.656 20v-2.197h-4.394V14.43q1.175-.255 2.325-1.175t1.61-2.044a5.36 5.36 0 0 0 3.423-1.789Q20 7.89 20 5.845V4.721q0-.87-.664-1.508-.665-.638-1.533-.638h-2.147V.377H4.721v2.198H2.575q-.87 0-1.533.638-.665.64-.665 1.508v1.124q0 2.044 1.38 3.577a5.36 5.36 0 0 0 3.424 1.789q.46 1.124 1.61 2.044 1.149.92 2.325 1.175v3.373H4.72V20zm-.184-10.943V4.906h2.264v1.113q0 2.278-2.264 3.038m-10.566 0q-2.264-.76-2.264-3.038V4.906h2.264z"
				/>
				<path
					fill="#FFF"
					fillRule="nonzero"
					d="M15.28 19.623v-2.198h-4.396v-3.372q1.176-.255 2.326-1.176t1.61-2.044a5.36 5.36 0 0 0 3.423-1.788q1.38-1.533 1.38-3.577V4.344q0-.87-.665-1.508-.665-.639-1.533-.639H15.28V0H4.344v2.197H2.197q-.868 0-1.533.64Q0 3.473 0 4.343v1.124Q0 7.51 1.38 9.045a5.36 5.36 0 0 0 3.423 1.788q.46 1.125 1.61 2.044 1.15.92 2.325 1.176v3.372H4.344v2.198zm-.186-10.944V4.53h2.264v1.113q0 2.278-2.264 3.037m-10.566 0Q2.264 7.92 2.264 5.642V4.528h2.264z"
				/>
				<use xlinkHref="#a" fill="#CD0400" />
			</g>
		</svg>
	);
}
